/**
 * @param {*} raw
 * @return {RateVideoModel.type}
 */
export const RateVideoModel = (raw) => ({
  videoId: raw.videoId || null,
  value: raw.value || 0,
});

/** @typedef {{videoId: string, value: number}} */
RateVideoModel.type = '';
